import arcoAjuda from "./arco-ajuda.webp";
import arcoAmeaca from "./arco-ameaca.webp";
import { CARDS_COMUNS_NORDESTE, CARDS_RAROS_NORDESTE } from "./cartas";
import fundoColecao from "./colecao.webp";
import mascoteCabeca from "./mascote-cabeca.webp";
import mascoteCorpo from "./mascote-corpo.webp";
import fundoSelecao from "./selecao.webp";
import fundoDesfocado from "./tabuleiro-desfocado.webp";
import fundoTabuleiro from "./tabuleiro.webp";

// Região NORDESTE, bioma Caatinga, mascote Tatu-bola.
//
// A primeira região, e por isso a PADRÃO: `getRegiao` cai nela para `trailRegion`
// desconhecida, e o CSS declara os valores dela como padrão dos tokens.
//
// A PASTA É A REGIÃO: descritor, cartas e toda a arte moram aqui, e nenhum nome de
// arquivo repete o id (`tabuleiro.webp`, não `trilha-bg-<regiao>-horizontal.webp`).
// Acrescentar uma região é encher uma pasta destas e escrever uma linha em
// `../index.js`; apagar uma é apagar a pasta. Ver "Como acrescentar uma região" no
// README do módulo.

export const MASCOTE_NORDESTE = {
  nome: "Tatu-bola",
  // corpo: momento "hero" (apresentação, encerramento).
  // cabeca: enquadramento fechado, para os slots pequenos (balão de fala de
  // 64px e o medalhão de 56px do nó de recompensa).
  corpo: mascoteCorpo,
  cabeca: mascoteCabeca,
  fala: "Oi, explorador(a)! Sou o Tatu-bola — minha espécie está ameaçada, e preciso da sua ajuda! Encara os desafios comigo e descubra como proteger meu lar. Bora?",
  // A fala do ENCERRAMENTO, com o álbum na tela. Sobre não contar as cartas, ver o
  // comentário no descritor do Norte — vale igual aqui, e pelo mesmo motivo.
  //
  // A voz é deliberadamente diferente da Onça: ela é grave e territorial ("minha
  // floresta"), ele é pequeno e caseiro. "casinha" é literalmente a palavra da carta
  // rara dele, e é o que o distingue em duas sílabas. "durmo sossegado" é fiel à
  // espécie — o tatu-bola se enrola quando tem medo, então dormir solto é o sinal de
  // que está seguro —, e é imagem concreta para uma criança de 6 anos. O masculino
  // vem carregado em "sossegado".
  falaEncerramento:
    "Descobrimos tudo isso juntos, aqui na minha Caatinga. Agora eu durmo sossegado: você já sabe como cuidar da minha casinha.",
  // O galho de álbum vazio, com o mesmo esqueleto do Norte de propósito: é o caminho
  // que quase ninguém vê, e paralelismo aqui vale mais que variação — quem escrever a
  // terceira região copia um molde. "todo orgulhoso" é o que o mantém tatuzinho e não
  // onça.
  falaEncerramentoSemCartas:
    "Você atravessou a Caatinga inteira comigo. Fiquei todo orgulhoso, e ainda tenho muita coisa pra te mostrar."
};

export const TABULEIRO_NORDESTE = {
  fundo: fundoTabuleiro,
  fundoDesfocado,
  // A ilustração de fundo da escolha do explorador e da apresentação do mascote. Era
  // compartilhada por todas as regiões até 05/08/2026, quando o Norte ganhou a sua —
  // e a da Caatinga passou a ser a da Caatinga.
  fundoSelecao,
  // A CENA do painel desta região na coleção de cartas (área de conquistas). É a
  // faixa de horizonte no topo do painel — a arte aparece nítida ali e dissolve no
  // degradê antes da primeira fileira de cartas.
  //
  // Fica em `tabuleiro` junto das outras três, e pela mesma razão que `fundoSelecao`:
  // é ARTE, e é `variaveisDaRegiao` quem a transforma em custom property. Não é do
  // tabuleiro, e nenhuma delas é a única que não é.
  //
  // Derivada por `ferramentas-da-trilha/gerar-fundo-conquistas.py` a 1800px de
  // largura — o número é de retina, não de tela: numa faixa de 1040px CSS a imagem
  // precisa de 1136px de altura para cobrir 1:1, e a 1400px ampliaria 1,48x.
  fundoColecao,
  // Largura/altura do tile. O CSS pede `background-size: auto 100%`, então a
  // largura do cenário na tela é sempre esta razão vezes a altura da faixa — é o
  // que impede a arte de deformar. Nunca fixar os dois eixos.
  proporcao: 2.2202,
  // 48 amostras da altura do leito, em % da faixa, ao longo do cenário.
  // Suavizadas CIRCULARMENTE, porque o cenário se repete: suavizar em linha reta
  // criaria um degrau exatamente na emenda.
  //
  // Uma delas é CALIBRADA e não medida: a 21 subiu 2,5pp (de 46,1 para 48,6). Ali
  // a estrada se estreita com um cacto no meio, e o centro de massa cai no vinco
  // escuro entre o leito e a parede. É por isso que o script confere o array em
  // vez de exigir que ele seja igual ao medido.
  perfilDaEstrada: [
    61.2, 58.0, 53.0, 48.1, 44.8, 43.6, 43.9, 45.2, 47.3, 49.7, 52.1, 53.8,
    54.8, 55.2, 55.4, 55.5, 55.4, 55.0, 53.5, 51.3, 49.0, 48.6, 43.5, 41.3,
    39.1, 37.8, 37.5, 37.8, 38.4, 38.9, 39.6, 41.2, 43.0, 44.5, 46.0, 47.3,
    48.2, 48.7, 48.4, 49.3, 50.6, 52.1, 54.3, 57.6, 61.1, 64.2, 64.6, 63.3
  ]
};

export const CORES_NORDESTE = {
  // Accent: borda do explorador escolhido, região destacada no mapa da abertura.
  region: "#f59e0b",
  regionStrong: "#b45309",
  // O degradê da casca, de cima para baixo: céu quente do sertão, areia, e o solo
  // do tabuleiro — a última parada emenda com a ilustração para a junção entre
  // fundo e arte não aparecer.
  fundoTopo: "#fbe3c2",
  fundoMeio: "#d99e63",
  fundoBase: "#5c3a21",
  // O véu sobre a ilustração embaçada do `::before`. São as três de cima com
  // alfa, e existem separadas porque custom property guarda a cor inteira —
  // aplicar transparência sobre elas pediria `color-mix()`, fora do alcance deste
  // AVA.
  veuTopo: "rgba(251, 227, 194, 0.5)",
  veuMeio: "rgba(217, 158, 99, 0.3)",
  veuBase: "rgba(92, 58, 33, 0.55)",
  // O véu RADIAL sobre a ilustração da escolha do explorador e da apresentação do
  // mascote — outra camada, outros valores: aquele degradê é vertical e cobre a
  // faixa do tabuleiro, este é elíptico do centro para as bordas e cobre uma
  // ilustração inteira atrás de figuras grandes. Explícitos aqui para a Caatinga
  // também dizer qual é o dela; eram os padrões do CSS.
  veuSelecaoCentro: "rgba(251, 227, 194, 0.5)",
  veuSelecaoMeio: "rgba(217, 158, 99, 0.25)",
  veuSelecaoBorda: "rgba(146, 92, 42, 0.1)",
  // O cromo (setas de navegação, pílula do contador) SOBRE o cenário. São os mesmos
  // âmbares que essas peças sempre usaram aqui — até 05/08/2026 elas liam
  // `--tl-color-reward`, que é o dourado de PRÊMIO, e portanto ficavam iguais em
  // toda região. Escritos explícitos para a Caatinga também dizer qual é o seu.
  chromeBorda: "#fbbf24",
  chromeTexto: "#d97706",
  chromeFundo: "#fef3c7"
};

// A FIGURA DO ARCO, na ordem de `cardsRaros` — ameaça primeiro, fecho por último.
//
// É a cena que o aluno vê no fim de leva quando a carta rara NÃO é sorteada (ver
// `cenaDaFase` em ../../../nucleo/recompensaDaFase.js): o mascote cabisbaixo na
// ameaça, de braços erguidos na ajuda, e nenhum prêmio.
//
// SÓ A ARTE, e é o ponto. Nome e fala do arco não estão aqui porque já existem: são
// os da carta que teria caído ali. Uma segunda cópia do texto no descritor
// divergiria da primeira no dia em que alguém ajustasse uma pílula em
// `TemasDaTrilhas/`, que é a fonte de verdade e de onde `gerar-cartas-trilha.py`
// gera `cartas.js`.
//
// LISTA E NÃO `{ ameaca, ajuda }`: quem casa fase rara com momento do arco é o
// alinhamento pelo fim, que trabalha com ÍNDICE. Com um objeto de dois nomes, o
// núcleo teria de saber que o índice 0 se chama "ameaca" — ou seja conheceria a
// narrativa da região, que é exatamente o que ele não faz.
//
// Derivada por `ferramentas-da-trilha/gerar-figuras-trilha.py` (modo `arco`) da arte
// da carta rara: fora a moldura de madeira, e a borda dissolvida.
export const ARCO_NORDESTE = [arcoAmeaca, arcoAjuda];

export const REGIAO_NORDESTE = {
  id: "nordeste",
  nome: "Nordeste",
  bioma: "Caatinga",
  mascote: MASCOTE_NORDESTE,
  cardsComuns: CARDS_COMUNS_NORDESTE,
  cardsRaros: CARDS_RAROS_NORDESTE,
  arco: ARCO_NORDESTE,
  tabuleiro: TABULEIRO_NORDESTE,
  cores: CORES_NORDESTE
};

// Reexportado para quem já importava daqui antes de as cartas saírem para
// `./cartas.js` — e porque o teste das regiões pede o conjunto.
export {
  CARDS_COMUNS_NORDESTE,
  CARDS_RAROS_NORDESTE,
  CARDS_NORDESTE
} from "./cartas";
